module.exports = __webpack_public_path__ + "static/media/yearn_finance.88f2e966.svg";